import * as types from '../mutation-types';
import actions from '../actions/userActions';

/**
 * Define the module state
 *
 * @type {object}
 */
const moduleState = {
    user: {},
    userId: '',
    isSmsCodeSent: false,
    phoneNumber: '',
};

const mutations = {
    [types.SET_SMS_CODE](state, userData) {
        state.userId = userData.userId;
        state.isSmsCodeSent = userData.isSmsCodeSent;
        state.phoneNumber = userData.phoneNumber;
    },

    [types.STORE_USER](state, userData) {
        state.user = userData;
    },
};

/**
 * Define the module getters
 *
 * @type {object}
 */
const getters = {
    user: (state) => state,
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: moduleState,
};
